export const getallslowmovingproducts = `
 query {

  allSlowMovingProducts {

    success

    error

    message

    data {

      id

      productCode

      productName

      productCategory

      brand

      ageOfStock

      reasonForSlowMovement

       slowMovingFor

            createdAt

      customer

      user {

        id

        username

        email

           employeeName,

      }

      product {

        id

        productCode

        productName

      }

    }

  }

}

`;

export const FilterSlowMovingProducts = `
   query FilterSlowMovingProducts(

    $startDate: Date

    $endDate: Date

    $brand: String

    $productCategory: String

    $slowMovingFor: String

  ) {

    filterSlowMovingProducts(

      startDate: $startDate

      endDate: $endDate

      brand: $brand

      productCategory: $productCategory

      slowMovingFor: $slowMovingFor

    ) {

      success

      error

      message

      data {

        id

        productCode

        productName

        productCategory

        brand

        ageOfStock

        reasonForSlowMovement

        slowMovingFor

        customer

        user{

          username

          employeeName

        }

        createdAt

      }

    }

  }
 
  `;

export const getslowproductsbyid = `
query GetSlowMovingProductById($id: Int!) {
  getSlowMovingProductById(id: $id) {
    success
    error
    message
    data {
      id
      productCode
      productName
      productCategory
      brand
      ageOfStock
      reasonForSlowMovement
      slowMovingFor
      customer{
        customerName
      }
      user{
        username
      }
      createdAt
    }
  }
}


`;

export const getAllCustomermasterDropdown = `
  query GetAllCustomerMasterDropdown($search: String) {
    getAllCustomermasterDropdown(search: $search) {
      success
      message
      data {
        id
        customerName
        customerCode
      }
    }
  }
`;

export const getMergedCustomerDropdown = `
 query{

  getMergedCustomerDropdown{

    success

    message

    data{

      customerCode

      customerName

      customerCategory

      status

      creditLimit

      creditPeriod

    }

  }

}
 
`;

export const slowmovingproductsreport = `
query SlowMovingProductReport(
  $startDate: Date
  $endDate: Date
  $productCategories: [String]
  $brands: [String]
  $userIds: [Int]
  $agentNames: [String]
  $agesOfStock: [Int]
  $productNames: [String]
) {
  slow_moving_product_report(
    start_date: $startDate
    end_date: $endDate
    product_categories: $productCategories
    brands: $brands
    user_ids: $userIds
    agent_names: $agentNames
    ages_of_stock: $agesOfStock
    product_names: $productNames
  ) {
    total_count
    items {
      product_name
      category
      brand
      stock_age
      quantity
      agent_name
      user_id
    }
  }
}



`;
